import { User as IUser } from "../types/auth-context";

export type IFollowers = {
  data: IUser[];
  meta: {
    current_page: number;
    last_page: number;
    total: number;
  };
};

export type IFollowing = {
  data: IUser[];
  meta: {
    current_page: number;
    last_page: number;
    total: number;
  };
};

export type ILastTopics = {
  data: any;
  meta: {
    total: number;
  };
};

export type ICollections = {
  data: any;
  meta: {
    total: number;
  };
};

export type IComments = {
  data: any;
  meta: {
    total: number;
  };
};

export interface userType {
  followers: IFollowers;
  following: IFollowing;
  lastTopics: ILastTopics;
  loggedUser?: IUser;
  user: IUser;
  collections: ICollections;
  comments: IComments;
}

const userData: IUser = {
  id: 0,
  first_name: "",
  last_name: "",
  full_name: "",
  username: "",
  display_name: "",
  user_title: "",
  addresses: [],
  email: "",
  phone: "",
  photo: "",
  document: "",
  gender: "",
  biography: "",
  birthday: null,
  active: false,
  admin: 0,
  blog_post_count: 0,
  blog_topic_count: 0,
  course_count: 0,
  lesson_count: 0,
  media_space_content_count: 0,
  site_public: "",
  address_public: "",
  phone_public: "",
  email_public: "",
  phones: [],
  cover_image: "",
  game_points: 0,
  game_credits: 0,
  promoter: false,
  unread_notifications: 0,
  unviewed_notifications: 0,
  has_recipient: false,
  superadmin: false,
};

const user: userType = {
  followers: {
    data: [],
    meta: {
      current_page: 0,
      last_page: 0,
      total: 0,
    },
  },
  following: {
    data: [],
    meta: {
      current_page: 0,
      last_page: 0,
      total: 0,
    },
  },
  lastTopics: {
    data: [
      {
        id: 0,
      },
    ],
    meta: {
      total: 0,
    },
  },
  loggedUser: userData,
  user: userData,
  collections: {
    data: [],
    meta: {
      total: 0,
    },
  },
  comments: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

export default user;
